import { useClientFetch } from '../context/ClientStatusContext';
import { ClientStatus } from '../model/ClientStatus';
import { fetchAutorZmenyList } from '../client/autorZmenyListClient';
import { Pouzivatel } from '../model/Pouzivatel';
import Uuid from '../model/Uuid';

interface ReturnType {
  pouzivatelia: Pouzivatel[];
  pouzivateliaStatus: ClientStatus;
}

export default (tezaurusUuid: Uuid): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(
    fetchAutorZmenyList,
    [tezaurusUuid],
    [tezaurusUuid],
  );

  return {
    pouzivatelia: data,
    pouzivateliaStatus: status,
  };
};
